<template>
        <div>
            <div class="custom-control custom-checkbox" style="padding-top:5px;" @click="toggleCheck">
                <input :name="checkboxname" type="checkbox" class="custom-control-input" :checked="isChecked">
                <label class="custom-control-label" for="check">{{ title }} {{ units }}: </label>
            </div>

            <div @click="toggleFilter">
                 <input :id="id" class="js-range-slider" data-layout="fixed"
                    type="text" :name="slidername"
                    :data-min="min_val" :data-max="max_val"
                    :data-from="min_val" :data-to="max_val"
                    data-type="double" data-grid="true"
                    :data-step="step"
                    :data-disable="isDisabled">

                <div class="row" v-show="isVisible">
                    <div class="md-form col">
                        <input :id="min_id" type="text" :name="min_id"
                                class="form-control"
                                :class="{'is-enabled': !isDisabled }"
                                v-model="min_val" :placeholder="min"
                                :disabled="isDisabled"
                                @change="updateLeftHandle"/>
                        <label>Min {{ units }}</label>
                    </div>
                    <div class="md-form col">
                        <input :id="max_id" type="text" :name="max_id"
                                class="form-control"
                                :class="{'is-enabled': !isDisabled }"
                                v-model="max_val" :placeholder="max"
                                :disabled="isDisabled"
                                @change="updateRightHandle"/>
                        <label>Max {{ units }}</label>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    export default {
        // props: ['min', 'max', 'step', 'title', 'units', "id", 'filter_max', 'filter_min'],
        props: {
                min: String,
                max: String,
                step: String,
                title: String,
                units: String,
                id: String,
                filter_max: {
                    type: String,
                    default: ""
                },
                filter_min: {
                    type: String,
                    default: ""
                }
            },

        data() {
            return {
                isVisible: false,
                isDisabled: true,
                isChecked: false,
                max_val: this.max,
                min_val: this.min,
                min_id: "min_" + this.id,
                max_id: "max_" + this.id
            }
        },

        computed: {
            checkboxname() {
                return "checkbox_" + this.id
            },
            slidername() {
                return "slider_" + this.id
            }
        },

        methods: {
            // check if filter ui is disable, if it is and user clicks on
            // the ui enable ui and enable checkbox.
            toggleFilter() {
                // toggle switch
                if (! this.isChecked) {
                    this.isDisabled = false
                    this.isChecked = true
                    this.isVisible = true

                    $("#"+this.id).data("ionRangeSlider").update({disable: this.isDisabled})
                }
            },

            toggleCheck() {
                this.isChecked = !this.isChecked
                this.isDisabled = !this.isDisabled
                this.isVisible = !this.isVisible
                $("#"+this.id).data("ionRangeSlider").update({disable: this.isDisabled})

                if (! this.isChecked) {
                    // if filter has been turned off broadcastEvent to remove
                    // from filter
                    this.broadcastEvent()
                } else {
                    // possible that check box was reactivated, first time
                    this.broadcastEvent(this.min_val, this.max_val)
                }
            },

            updateRightHandle() {
                $("#"+this.id).data("ionRangeSlider").update({to: this.max_val})

                // onChange to max_val send ajax request to server
                this.broadcastEvent(this.min_val, this.max_val)
            },

            updateLeftHandle() {
                $("#"+this.id).data("ionRangeSlider").update({from: this.min_val})

                // onChange to min_val send ajax request to server
                this.broadcastEvent(this.min_val, this.max_val)
            },

            broadcastEvent(min='', max='') {
                // datatables is outside the scope of vuejs
                // hence static trigger set to send and update datatables event
                // with min, max value and the type of minmax value being updated.
                $(document).trigger('SliderUpdate', [{'min': min, 'max': max,
                                                      'id': this.id}])
            },

            reset() {
                this.isVisible = false
                this.isDisabled = true
                this.isChecked = false
                this.max_val = this.max
                this.min_val = this.min

                this.updateRightHandle()
                this.updateLeftHandle()
            }
        },

        mounted () {
            var _this = this

            // initalize ionRangeSlider and update function
            // need this as ion slider doesn't work well with vuejs
            $("#"+this.id).ionRangeSlider({
                // use onFinish instead of onUpdate else for every slider move
                // event will be broadcasted instead of one event when user
                // has completed the slider movement
                onFinish: function(data) {
                    _this.min_val = data.from
                    _this.max_val = data.to

                    // onChange to min_val/max_val send ajax request to server
                    _this.broadcastEvent(_this.min_val, _this.max_val)
                }
            });

            $(document).on('reset', this.reset)

            // strict equality operator (===) to check whether a string is empty or not.
            if (this.filter_max !== "" || this.filter_min !== "") {
                this.isDisabled = false
                this.isChecked = true
                this.isVisible = true
                $("#"+this.id).data("ionRangeSlider").update({disable: this.isDisabled})
            }
            if (this.filter_max !== "") {
                this.max_val = this.filter_max
                this.updateRightHandle()
            }
            if (this.filter_min !== "") {
                this.min_val = this.filter_min
                this.updateLeftHandle()
            }
        },

        watch: {
            min_val() {
                //
            },
            max_val() {
                //
            }
        }
    }
</script>
